module.exports = __webpack_public_path__ + "static/media/oldman.b77c7fb8.svg";